export default "__VITE_ASSET__DVtd1hXb__"